import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import type { UseStudyPeriodSectionResult } from '../types';
import { useInheritedStudyPeriod } from './useInheritedStudyPeriod';
import { formatIsoDate } from '../utils/formatIsoDate';

// `parentLoading` is the section's own `isLoading` prop (the definition tab
// still hydrating) — combined here with the inherited-study-period fetch's
// loading state so the container only needs a single `isLoading` flag.
export const useStudyPeriodSection = (parentLoading = false): UseStudyPeriodSectionResult => {
  const { formatMessage } = useIntl();
  const {
    startDate,
    endDate,
    isSet,
    inheritedFromCohortName,
    isLoading: isPeriodLoading,
  } = useInheritedStudyPeriod();

  const dateRangeText = useMemo(
    () => `${formatIsoDate(startDate)} – ${formatIsoDate(endDate)}`,
    [startDate, endDate]
  );

  return {
    sectionLabel: formatMessage({ id: 'analysisDetail.studyPeriod.label' }),
    isSet,
    dateRangeText,
    inheritedFromCohortName,
    notSetText: formatMessage({ id: 'analysisDetail.studyPeriod.notDefined' }),
    isLoading: parentLoading || isPeriodLoading,
  };
};
